import { withCustomer } from '@catalogo/core-connect/customer';
import React, { useEffect, useState } from 'react';
import compose from 'lodash/fp/compose';
import { useQuery } from '@apollo/client';
import { getQuestionList } from '../../queries/qna.graphql';
import { getCustomerQuestions } from '../helpers';

export const withCustomerQuestions = Component => props => {
  const { productId, customer } = props;
  const [customerQuestions, setCustomerQuestions] = useState([]);

  const queryVariables = {
    term: '',
    limit: 1,
    offset: 0,
    sort: 'likes',
    answersLimit: 1,
    sellerId: 'all',
    condition: 'answered',
  };

  const { data } = useQuery(getQuestionList, {
    variables: {
      ...queryVariables,
      productId,
      ownerId: customer?.id,
    },
    skip: !customer?.id,
  });

  useEffect(() => {
    if (customer?.id && data) {
      setCustomerQuestions(getCustomerQuestions(data));
    }
  }, [data]);

  return (
    <Component hasCustomerQuestions={customerQuestions?.length > 0} customerQuestions={customerQuestions} {...props} />
  );
};

export default compose(withCustomer, withCustomerQuestions);
